import { colors } from '../../../../../../../../../colorVars';
import { Body3 } from '../../../../../../../../../components/atomic/text/Text';

export function alreadyFlatteningBuilder({parsedStatusObj}) {
  return (
    <td>
      <Body3 fontWeight={500} color={colors.lightGrey}>
        Cannot complete action,
        {parsedStatusObj.symbol ? parsedStatusObj.symbol : ''} trade plan is
        already flattening.
      </Body3>
    </td>
  );
}
